import {
  Button,
  makeStyles,
  mergeClasses,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { Pause20Regular, Play20Regular } from '@fluentui/react-icons';
import React from 'react';

const styles = makeStyles({
  playPause: {
    ...shorthands.border('none'),
    height: '24px',
    backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 60%, transparent)`,
    paddingTop: `${tokens.spacingVerticalXXS}`,
    paddingRight: `${tokens.spacingHorizontalS}`,
    paddingBottom: `${tokens.spacingVerticalXXS}`,
    paddingLeft: `${tokens.spacingHorizontalS}`,
    rowGap: `${tokens.spacingHorizontalXS}`,
    columnGap: `${tokens.spacingHorizontalXS}`,
    color: tokens.colorNeutralBackground5,
    ':hover': {
      backgroundColor: tokens.colorNeutralForeground1,
      color: tokens.colorNeutralBackground5,
    },
    ':hover:active': {
      backgroundColor: tokens.colorNeutralForeground1,
      color: tokens.colorNeutralBackground5,
    },
  },
  playerTimeSeparator: {
    ...shorthands.padding('0', tokens.spacingHorizontalXS),
  },
});

export const PlayPauseButton = ({ usePlayPause }) => {
  const classes = styles();
  const { props, playing } = usePlayPause();

  return (
    <Button
      {...props}
      className={mergeClasses('play-pause-btn', classes.playPause)}
      appearance="secondary"
      icon={playing ? <Pause20Regular /> : <Play20Regular />}
    />
  );
};
